module.exports = __webpack_public_path__ + "static/images/logo-ou.3237bfd15aa843a0ec0ace1085426b52.png";